import React, { useEffect, useRef, useState } from "react";
import { Form, Formik, FormikHelpers } from "formik";
import { postStateTaxes } from "../../../services/api-services/stateTaxService";
import { formSubmitErrorHandler } from "../../../services/formService";
import {
  createFormAnswers,
  createValidationSchema,
  initializeEmployeeState,
  initializeForm,
} from "../../common/stateTaxesFormFieldsFormatter";
import UiModal from "../../common/ui/UiModal";
import { State, StateTaxes } from "../models/user-interface";
import StateTaxesForm from "../user-forms/StateTaxesForm";

interface ModalProps {
  open: boolean;
  handleClose: (result?: any, action?: any) => void;
  stateTaxInfo: StateTaxes | undefined;
  StateTaxUpdateCallback: (result?: any) => void;
  usStates: State[];
}
export default function StateTaxInfoEditModal(props: ModalProps) {
  const { open, handleClose, stateTaxInfo, usStates, StateTaxUpdateCallback } =
    props;
  const title = "Edit State Tax Information";
  const [intialFormValues, setInitialFormValues] = useState<any>({});
  const [validationSchema, setValidationSchema] = useState<any>({});
  const [employeeState, setEmployeeState] = useState<any>([]);
  const formRef: any = useRef();
  const [isShowFooterLoader, setIsShowFooterLoader] = useState<boolean>(false);

  const initializeFormValues = () => {
    const intialValues = initializeForm(stateTaxInfo);
    setInitialFormValues(intialValues);
  };
  const newValidationSchema = () => {
    const validationSchema = createValidationSchema(stateTaxInfo);
    setValidationSchema(validationSchema);
  };

  const fetchStateObject = () => {
    const state = stateTaxInfo?.state;
    if (!state || !usStates) return;
    const employeeState = initializeEmployeeState(state, usStates);
    setEmployeeState(employeeState);
  };

  const onSubmit = (formData, formHelpers: FormikHelpers<any>) => {
    const data = createFormAnswers(formData, stateTaxInfo);
    setIsShowFooterLoader(true);
    formSubmitErrorHandler(
      postStateTaxes(data).then((res: any) => {
        setIsShowFooterLoader(false);
        StateTaxUpdateCallback(res?.data);
      }),
      () => {
        setIsShowFooterLoader(false);
      },
      formHelpers.setFieldError
    );
  };
  useEffect(() => {
    if (!stateTaxInfo) return;
    initializeFormValues();
    newValidationSchema();
    fetchStateObject();
  }, [stateTaxInfo]);
  return (
    <>
      <UiModal
        open={open}
        handleClose={handleClose}
        title={title}
        handleSave={() => {
          formRef.current?.handleSubmit();
        }}
        showFooterLoader={isShowFooterLoader}
      >
        <div className="state-taxes">
          <Formik
            initialValues={intialFormValues}
            validationSchema={validationSchema}
            enableReinitialize
            onSubmit={onSubmit}
            innerRef={formRef}
          >
            {() => {
              return (
                <div className="state-taxes">
                  <Form>
                    <div className="user-details--section">
                      <StateTaxesForm
                        employeeData={stateTaxInfo}
                        employeeState={employeeState}
                      />
                    </div>
                  </Form>
                </div>
              );
            }}
          </Formik>
        </div>
      </UiModal>
    </>
  );
}
